import {
    ACCURACY, COMPREHENSION, DAZE, WR, FLUENCY_COMPREHENSION, LN, RAN, OBSERVATIONAL_MEASURE,
    RCT, SPELLING, SPELLING_SPA, TRO, VOCAB, MAZE, VOCAB_SPA, DECODING_ONLINE, LC, CLPL,
} from './measure';
import { WR_OPENING } from './url';
import { LANGUAGE } from './language';
import RANServiceClient from '../common/clients/RANServiceClient';
import DNOServiceClient from '../common/clients/DNOServiceClient';
import { STATUS } from './result';
import VocaboServiceClient from '../common/clients/VocaboServiceClient';

const PLAYLIST_SUPPORTED_ITEMS = [
    {
        key: LN.ASSESSMENT,
        name: 'Letter Naming',
        type: LN.MEASURE,
        language: LANGUAGE.ENG,
        measure: LN.NAME,
        measureType: ACCURACY,
        startingURL: 'ln/practice',
        status: STATUS.NOT_STARTED,
    },
    {
        key: ACCURACY,
        name: 'Accuracy',
        type: OBSERVATIONAL_MEASURE.DORF,
        startingURL: 'rct/opening',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: DNOServiceClient.CLIENT_TO_SERVER_MEASURE_NAME[RCT],
        measureType: ACCURACY,
    },
    {
        key: FLUENCY_COMPREHENSION,
        name: 'Fluency / Comprehension',
        type: OBSERVATIONAL_MEASURE.DORF,
        startingURL: 'rct/fluency/model',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: DNOServiceClient.CLIENT_TO_SERVER_MEASURE_NAME[RCT],
        measureType: COMPREHENSION,
    },
    {
        key: DAZE,
        name: 'Daze',
        type: OBSERVATIONAL_MEASURE.DAZE,
        startingURL: 'daze/model',
        assessmentURL: 'daze/instructions',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: DNOServiceClient.CLIENT_TO_SERVER_MEASURE_NAME[DAZE],
        measureType: COMPREHENSION,
    },
    {
        key: MAZE.ASSESSMENT,
        name: MAZE.NAME,
        type: MAZE.MEASURE,
        startingURL: 'maze/model',
        assessmentURL: 'maze/instructions',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: MAZE.MEASURE,
        measureType: COMPREHENSION,
    },
    {
        key: VOCAB.TQVM,
        name: VOCAB.FULL_NAME,
        group: VOCAB.ASSESSMENT,
        type: VocaboServiceClient.MEASURES.TQVM,
        startingURL: 'vocab/tqvm/practice',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: VocaboServiceClient.MEASURES.TQVM,
    },
    {
        key: VOCAB.FITB,
        name: VOCAB.FULL_NAME,
        group: VOCAB.ASSESSMENT,
        type: VocaboServiceClient.MEASURES.FITB,
        startingURL: 'vocab/fitb/practice',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: VocaboServiceClient.MEASURES.FITB,
    },
    {
        key: VOCAB.BD,
        name: VOCAB.FULL_NAME,
        group: VOCAB.ASSESSMENT,
        type: VocaboServiceClient.MEASURES.BD,
        startingURL: 'vocab/bd/practice',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: VocaboServiceClient.MEASURES.BD,
    },
    {
        key: SPELLING.ASSESSMENT,
        name: SPELLING.FULL_NAME,
        group: SPELLING.ASSESSMENT,
        type: SPELLING.SPELLING,
        startingURL: 'spelling/practice',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: SPELLING.MEASURE_API_KEY,
    },
    {
        key: TRO.ASSESSMENT,
        name: 'TRO',
        type: TRO.MEASURE,
        startingURL: 'trc/instructions',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: TRO.MEASURE,
    },
    {
        key: WR.KEY,
        // so far we have only one WR measure, so let it be named "Decoding Online" on the main page
        name: DECODING_ONLINE.FULL_NAME,
        type: WR.MEASURE,
        startingURL: WR_OPENING,
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: WR.MEASURE,
        measureType: ACCURACY,
    },
    {
        key: LC.MEASURE,
        name: 'LC',
        type: LC.LISTEN_COMP,
        startingURL: 'lc/reading',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: LC.MEASURE,
    },
    {
        key: RAN.MEASURE,
        name: RAN.FULL_NAME,
        type: RANServiceClient.MEASURES['RAN-NUMBERS'],
        startingURL: 'ran/numbers/directions',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.ENG,
        measure: RAN.FULL_NAME,
        measureType: RAN.NUMBERS,
    },
    {
        key: CLPL.ASSESSMENT,
        name: CLPL.NAME,
        type: CLPL.MEASURE,
        startingURL: `${CLPL.ASSESSMENT}/model`,
        assessmentURL: `${CLPL.ASSESSMENT}/instructions`,
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.SPA,
        measure: CLPL.MEASURE,
        measureType: COMPREHENSION,
    },
    {
        key: `${VOCAB.TQVM}-${LANGUAGE.SPA}`,
        name: VOCAB_SPA.FULL_NAME,
        group: VOCAB.ASSESSMENT,
        type: VOCAB_SPA.TQVM,
        startingURL: 'vocab/tqvm/practice?lang=spa',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.SPA,
        measure: VocaboServiceClient.MEASURES.TQVM,
    },
    {
        key: `${VOCAB.FITB}-${LANGUAGE.SPA}`,
        name: VOCAB_SPA.FULL_NAME,
        group: VOCAB.ASSESSMENT,
        type: VOCAB_SPA.FITB,
        startingURL: 'vocab/fitb/practice?lang=spa',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.SPA,
        measure: VocaboServiceClient.MEASURES.FITB,
    },
    {
        key: `${VOCAB.BD}-${LANGUAGE.SPA}`,
        name: VOCAB_SPA.FULL_NAME,
        group: VOCAB.ASSESSMENT,
        type: VOCAB_SPA.BD,
        startingURL: 'vocab/bd/practice?lang=spa',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.SPA,
        measure: VocaboServiceClient.MEASURES.BD,
    },
    {
        key: `${SPELLING.ASSESSMENT}-${LANGUAGE.SPA}`,
        name: SPELLING_SPA.FULL_NAME,
        group: SPELLING.ASSESSMENT,
        type: SPELLING_SPA.SPELLING,
        startingURL: 'spelling/practice?lang=spa',
        status: STATUS.NOT_STARTED,
        language: LANGUAGE.SPA,
        measure: SPELLING.MEASURE_API_KEY,
    },
];

export default PLAYLIST_SUPPORTED_ITEMS;
